export default "__VITE_ASSET__Bgrt_hGB__"